import { render, staticRenderFns } from "./ColumnTitle.vue?vue&type=template&id=585248f2&scoped=true"
import script from "./ColumnTitle.vue?vue&type=script&lang=js"
export * from "./ColumnTitle.vue?vue&type=script&lang=js"
import style0 from "./ColumnTitle.vue?vue&type=style&index=0&id=585248f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585248f2",
  null
  
)

export default component.exports